import Vue from 'vue'
import axios from 'axios';
import router from '../router';
import Auth from '../utilities/Auth'
import Notifications from 'vue-notification'

Vue.use(Notifications)


function errorResponseHandler(error) {

    NProgress.done()

    const { status } = error.response;
    console.log(error.response)

    if (status === 401) {  // unauthorized

        Auth.destroyToken();

        router.replace('/login');
    }

    if (status == 400) { // Bad Request

        const { message, status } = error.response.data;
        if ('message' in error.response.data && message instanceof Object) { 
            // Form validations              
            for (let [key, value] of Object.entries(message)) {
                
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: `${value}`
                })
            }
        } else {
            
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: message
            })
        }
    }

    if (status == 404) { // Not found exception

        Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: error.response.data.message
        })
    }

    if (status == 500) { // Server Error
        Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Something has gone wrong. Don\'t fret, you didn\'t cause this.'
        })        
    }
      
    return Promise.reject(error.response);
}

// response interceptor
axios.interceptors.response.use((response) => {

    NProgress.done()
  
    return response;
}, 
    errorResponseHandler
);


export default errorResponseHandler;